import { UploadStatus } from "@/shared/enums/upload-status";

interface StatusConfig {
	icon: string;
	text: string;
	progressWidth: string;
}

/**
 * Configuración de iconos, textos y progreso para cada estado de upload
 */
export const UPLOAD_STATUS_CONFIG: Record<UploadStatus, StatusConfig> = {
	[UploadStatus.UPLOADING]: {
		icon: "mdi mdi-cloud-upload upload-spinning",
		text: "catalogue.status.uploading",
		progressWidth: "45%",
	},
	[UploadStatus.ANALYZING]: {
		icon: "mdi mdi-brain upload-spinning",
		text: "catalogue.status.analyzing",
		progressWidth: "85%",
	},
	[UploadStatus.COMPLETED]: {
		icon: "mdi mdi-check-circle upload-completed",
		text: "catalogue.status.completed",
		progressWidth: "100%",
	},
	[UploadStatus.UPLOADING_ERROR]: {
		icon: "mdi mdi-alert-circle upload-error",
		text: "catalogue.status.error",
		progressWidth: "10%",
	},
	[UploadStatus.ANALYZING_ERROR]: {
		icon: "mdi mdi-alert-circle upload-error",
		text: "catalogue.status.error",
		progressWidth: "10%",
	},
	[UploadStatus.PENDING]: {
		icon: "mdi mdi-clock-outline upload-pending",
		text: "catalogue.status.pending",
		progressWidth: "10%",
	},
};

/**
 * Clases CSS para las posiciones del toast
 */
export const POSITION_CLASSES = {
	"top-right": "upload-toast-top-right",
	"top-left": "upload-toast-top-left",
	"bottom-right": "upload-toast-bottom-right",
	"bottom-left": "upload-toast-bottom-left",
} as const;

export type ToastPosition = keyof typeof POSITION_CLASSES;
